module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "module-title"
  }, [_c('router-link', {
    attrs: {
      "to": '/a/module/' + _vm.module.id
    }
  }, [_vm._v(_vm._s(_vm.module.title))])], 1), _vm._v(" "), _c('span', {
    staticClass: "module-options"
  }, [_c('router-link', {
    staticClass: "edit",
    attrs: {
      "title": "Edit Module",
      "to": '/a/module/' + _vm.module.id
    }
  }, [_c('span', [_c('i', {
    staticClass: "icon icon-edit"
  })])]), _vm._v(" "), _c('span', {
    attrs: {
      "title": "Make a Copy"
    }
  }, [_c('i', {
    staticClass: "icon icon-doc-copy",
    on: {
      "click": function($event) {
        _vm.duplicate()
      }
    }
  })]), _vm._v(" "), _c('span', {
    attrs: {
      "title": "Delete Module"
    }
  }, [_c('i', {
    staticClass: "icon icon-trash",
    on: {
      "click": function($event) {
        _vm.deleteModule()
      }
    }
  })])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d4337fe","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/partials/module-line-item.vue
// module id = 520
// module chunks = 0